import type { Subtitle, SubtitlesPositions, SubtitlesSize } from '../../../components/subtitles/types';
import type { Message } from '../chat/types';

export interface SubtitlesState {
  group: SubtitlesGroup;
  isEnabled: boolean;
  isOnboarded: boolean;
  positionsRaw: Record<string, SubtitlesPositions>;
  size: SubtitlesSize;
  subtitle: Subtitle;
}

export enum SubtitlesGroup {
  GROUP1 = 'gr1',
  GROUP2 = 'gr2',
  GROUP3 = 'gr3',
}

export interface SubtitlesMessage extends Message {
  isFinal?: boolean;
}
